import { useCallback } from 'react';

export const useCancelPreview = (refreshPage: () => Promise<void>) => {
  const cancelPreview = useCallback<
    (e: React.MouseEvent<HTMLButtonElement>) => void
  >(
    (e) => {
      e.preventDefault();
      refreshPage();
    },
    [refreshPage],
  );

  return { cancelPreview };
};
